/* eslint-disable */
import React from 'react'
import { CModal, CModalBody, CProgress, CProgressBar } from '@coreui/react'
import { MUTATION_LOADING_MESSAGE } from 'src/helper/loadingPolicy'

const LoadingModal = ({ loadingModal, msg }) => {
  return (
    <>
      <CModal visible={loadingModal} alignment="center" backdrop="static" keyboard={false}>
        <CModalBody>
          {msg ? msg : MUTATION_LOADING_MESSAGE}

          <CProgress className="mb-3">
            <CProgressBar color="info" variant="striped" animated value={100} />
          </CProgress>
        </CModalBody>
      </CModal>
    </>
  )
}

export default LoadingModal
